import { createSlice } from '@reduxjs/toolkit';
import pageMeta from '../../models/pagemeta.model';
import PD from '../../models/pressrelease-downloads.model';

interface stateInterface{

  pressReleases:Array<PD>|undefined,
  loadingPressRelease:boolean,
  errorPressRelease:any|undefined,
  metaPressRelease:pageMeta|undefined,
  downloads:Array<PD>|undefined,
  loadingDownloads:boolean,
  errorDownloads:any|undefined,
  metaDownloads:pageMeta|undefined,

}

const intialState:stateInterface = {
  pressReleases:undefined,
  loadingPressRelease:false,
  errorPressRelease:undefined,
  metaPressRelease:undefined,
  downloads:undefined,
  errorDownloads:undefined,
  loadingDownloads:false,
  metaDownloads:undefined
}


const  createPDslice = createSlice({
  name:'prease-downloads',
  initialState:intialState,
  reducers:{

    fetchPRrequest(state){
      state.loadingPressRelease = true;
    },

    fetchPRsuccess(state,actions){
      state.loadingPressRelease = false;
      state.pressReleases = actions.payload.pressReleases;
      state.metaPressRelease = actions.payload.meta;
    },

    fetchPRfail(state,actions){
      state.loadingPressRelease = false;
      state.errorPressRelease = actions.payload;
    },

    fetchDownloadsrequest(state){
      state.loadingDownloads = true;
    },

    fetchDownloadssuccess(state,actions){
      state.loadingDownloads = false;
      state.downloads = actions.payload.downloads;
      state.metaDownloads = actions.payload.meta;
    },

    fetchDownloadsfail(state,actions){
      state.loadingDownloads = false;
      state.errorDownloads = actions.payload;
    },
  }
});

export const {
  fetchDownloadsfail,
  fetchDownloadsrequest,
  fetchDownloadssuccess,

  fetchPRfail,
  fetchPRrequest,
  fetchPRsuccess,

} = createPDslice.actions;


export default createPDslice.reducer;